import tw from 'twin.macro';
import { Color } from '@teetsh/app/src/types/colors';

export const ringColors: Record<Color, any> = {
  black: tw`ring-black`,
  'gray-900': tw`ring-gray-900`,
  'gray-800': tw`ring-gray-800`,
  'gray-700': tw`ring-gray-700`,
  'gray-600': tw`ring-gray-600`,
  'gray-500': tw`ring-gray-500`,
  'gray-400': tw`ring-gray-400`,
  'gray-300': tw`ring-gray-300`,
  'gray-200': tw`ring-gray-200`,
  'gray-100': tw`ring-gray-100`,
  'gray-50': tw`ring-gray-50`,

  'purple-100': tw`ring-purple-100`,
  'purple-200': tw`ring-purple-200`,
  'purple-300': tw`ring-purple-300`,
  'purple-400': tw`ring-purple-400`,
  'purple-50': tw`ring-purple-50`,
  'purple-500': tw`ring-purple-500`,
  'purple-600': tw`ring-purple-600`,
  'purple-700': tw`ring-purple-700`,
  'purple-800': tw`ring-purple-800`,
  'purple-900': tw`ring-purple-900`,
  'amber-100': tw`ring-amber-100`,
  'amber-200': tw`ring-amber-200`,
  'amber-300': tw`ring-amber-300`,
  'amber-400': tw`ring-amber-400`,
  'amber-50': tw`ring-amber-50`,
  'amber-500': tw`ring-amber-500`,
  'amber-600': tw`ring-amber-600`,
  'amber-700': tw`ring-amber-700`,
  'amber-800': tw`ring-amber-800`,
  'amber-900': tw`ring-amber-900`,
  'cobalt-100': tw`ring-cobalt-100`,
  'cobalt-200': tw`ring-cobalt-200`,
  'cobalt-300': tw`ring-cobalt-300`,
  'cobalt-400': tw`ring-cobalt-400`,
  'cobalt-50': tw`ring-cobalt-50`,
  'cobalt-500': tw`ring-cobalt-500`,
  'cobalt-600': tw`ring-cobalt-600`,
  'cobalt-700': tw`ring-cobalt-700`,
  'cobalt-800': tw`ring-cobalt-800`,
  'cobalt-900': tw`ring-cobalt-900`,
  'emerald-100': tw`ring-emerald-100`,
  'emerald-200': tw`ring-emerald-200`,
  'emerald-300': tw`ring-emerald-300`,
  'emerald-400': tw`ring-emerald-400`,
  'emerald-50': tw`ring-emerald-50`,
  'emerald-500': tw`ring-emerald-500`,
  'emerald-600': tw`ring-emerald-600`,
  'emerald-700': tw`ring-emerald-700`,
  'emerald-800': tw`ring-emerald-800`,
  'emerald-900': tw`ring-emerald-900`,
  'green-100': tw`ring-green-100`,
  'green-200': tw`ring-green-200`,
  'green-300': tw`ring-green-300`,
  'green-400': tw`ring-green-400`,
  'green-50': tw`ring-green-50`,
  'green-500': tw`ring-green-500`,
  'green-600': tw`ring-green-600`,
  'green-700': tw`ring-green-700`,
  'green-800': tw`ring-green-800`,
  'green-900': tw`ring-green-900`,
  'indigo-100': tw`ring-indigo-100`,
  'indigo-200': tw`ring-indigo-200`,
  'indigo-300': tw`ring-indigo-300`,
  'indigo-400': tw`ring-indigo-400`,
  'indigo-50': tw`ring-indigo-50`,
  'indigo-500': tw`ring-indigo-500`,
  'indigo-600': tw`ring-indigo-600`,
  'indigo-700': tw`ring-indigo-700`,
  'indigo-800': tw`ring-indigo-800`,
  'indigo-900': tw`ring-indigo-900`,
  'blue-100': tw`ring-blue-100`,
  'blue-200': tw`ring-blue-200`,
  'blue-300': tw`ring-blue-300`,
  'blue-400': tw`ring-blue-400`,
  'blue-50': tw`ring-blue-50`,
  'blue-500': tw`ring-blue-500`,
  'blue-600': tw`ring-blue-600`,
  'blue-700': tw`ring-blue-700`,
  'blue-800': tw`ring-blue-800`,
  'blue-900': tw`ring-blue-900`,
  'lime-100': tw`ring-lime-100`,
  'lime-200': tw`ring-lime-200`,
  'lime-300': tw`ring-lime-300`,
  'lime-400': tw`ring-lime-400`,
  'lime-50': tw`ring-lime-50`,
  'lime-500': tw`ring-lime-500`,
  'lime-600': tw`ring-lime-600`,
  'lime-700': tw`ring-lime-700`,
  'lime-800': tw`ring-lime-800`,
  'lime-900': tw`ring-lime-900`,
  'orange-100': tw`ring-orange-100`,
  'orange-200': tw`ring-orange-200`,
  'orange-300': tw`ring-orange-300`,
  'orange-400': tw`ring-orange-400`,
  'orange-50': tw`ring-orange-50`,
  'orange-500': tw`ring-orange-500`,
  'orange-600': tw`ring-orange-600`,
  'orange-700': tw`ring-orange-700`,
  'orange-800': tw`ring-orange-800`,
  'orange-900': tw`ring-orange-900`,
  'pink-100': tw`ring-pink-100`,
  'pink-200': tw`ring-pink-200`,
  'pink-300': tw`ring-pink-300`,
  'pink-400': tw`ring-pink-400`,
  'pink-50': tw`ring-pink-50`,
  'pink-500': tw`ring-pink-500`,
  'pink-600': tw`ring-pink-600`,
  'pink-700': tw`ring-pink-700`,
  'pink-800': tw`ring-pink-800`,
  'pink-900': tw`ring-pink-900`,
  'red-100': tw`ring-red-100`,
  'red-200': tw`ring-red-200`,
  'red-300': tw`ring-red-300`,
  'red-400': tw`ring-red-400`,
  'red-50': tw`ring-red-50`,
  'red-500': tw`ring-red-500`,
  'red-600': tw`ring-red-600`,
  'red-700': tw`ring-red-700`,
  'red-800': tw`ring-red-800`,
  'red-900': tw`ring-red-900`,
  'rose-100': tw`ring-rose-100`,
  'rose-200': tw`ring-rose-200`,
  'rose-300': tw`ring-rose-300`,
  'rose-400': tw`ring-rose-400`,
  'rose-50': tw`ring-rose-50`,
  'rose-500': tw`ring-rose-500`,
  'rose-600': tw`ring-rose-600`,
  'rose-700': tw`ring-rose-700`,
  'rose-800': tw`ring-rose-800`,
  'rose-900': tw`ring-rose-900`,
  'teal-100': tw`ring-teal-100`,
  'teal-200': tw`ring-teal-200`,
  'teal-300': tw`ring-teal-300`,
  'teal-400': tw`ring-teal-400`,
  'teal-50': tw`ring-teal-50`,
  'teal-500': tw`ring-teal-500`,
  'teal-600': tw`ring-teal-600`,
  'teal-700': tw`ring-teal-700`,
  'teal-800': tw`ring-teal-800`,
  'teal-900': tw`ring-teal-900`,
  'yellow-100': tw`ring-yellow-100`,
  'yellow-200': tw`ring-yellow-200`,
  'yellow-300': tw`ring-yellow-300`,
  'yellow-400': tw`ring-yellow-400`,
  'yellow-50': tw`ring-yellow-50`,
  'yellow-500': tw`ring-yellow-500`,
  'yellow-600': tw`ring-yellow-600`,
  'yellow-700': tw`ring-yellow-700`,
  'yellow-800': tw`ring-yellow-800`,
  'yellow-900': tw`ring-yellow-900`,

  white: tw`ring-white`,
};
